import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { call, put, takeLatest } from 'redux-saga/effects';
import { doLogin } from '@login/api/LoginApi';
import { AxiosResponse } from 'axios';
import { encryptData } from '@utils/crypto';
import { LoginResponse, LoginState } from '@login/types/LoginTypes';

// 초기 상태
const initialState: LoginState = {
  isLoggedIn: false,
  token: null,
  userName: null,
  userEmail: null,
  userId: null,
  guestYn: null,
  loading: false,
  error: false,
};

// Redux Slice 설정
const loginSlice = createSlice({
  name: 'login',
  initialState,
  reducers: {
    loginRequest: (
      state,
      action: PayloadAction<{ userId: string; password: string }>,
    ) => {
      state.loading = true;
      state.error = false;
    },
    loginSuccess: (
      state,
      action: PayloadAction<{
        token: string;
        userName: string;
        userEmail: string;
        userId: number;
        guestYn: string;
      }>,
    ) => {
      state.isLoggedIn = true;
      state.token = action.payload.token;
      state.userName = action.payload.userName;
      state.userEmail = action.payload.userEmail;
      state.userId = action.payload.userId;
      state.guestYn = action.payload.guestYn;
      state.loading = false;
      state.error = false;
    },
    loginFailure: (state) => {
      state.loading = false;
      state.error = true;
    },
    logout: (state) => {
      state.isLoggedIn = false;
      state.token = null;
      state.userName = null;
      state.userEmail = null;
      state.userId = null;
    },
  },
});

export const { loginRequest, loginSuccess, loginFailure, logout } =
  loginSlice.actions;
export default loginSlice.reducer;

// Redux-Saga 설정
function* handleLogin(
  action: PayloadAction<{ userId: string; password: string }>,
) {
  const response: LoginResponse = yield call(
    doLogin,
    action.payload.userId,
    action.payload.password,
  );
  yield put(
    loginSuccess({
      token: encryptData(response.result.token),
      userName: encryptData(response.result.userName),
      userEmail: encryptData(response.result.userEmail),
      userId: response.result.userId,
      guestYn: response.result.guestYn,
    }),
  );
}

function* handleLoginFailure(action: ReturnType<typeof loginRequest>) {
  yield put(loginFailure());
}

export function* watchLogin() {
  yield takeLatest(loginRequest.type, handleLogin);
  yield takeLatest(loginFailure.type, handleLoginFailure);
}
